const routes = {
    home: '/',
    adminDashboard: '/admin/dashboard',
    adminProducts: '/admin/products',
    adminCustomers: '/admin/customers',
    adminOrders: '/admin/orders',
    adminCategory: '/admin/categories',
    createProduct: '/admin/products/create',
    adminCustomerDtl: '/admin/customers/detail/:id',
    adminInquiry: '/admin/inquiries',
    adminOrderDtl: '/admin/orders/:id',
    adminReview: '/admin/reviews',
    adminWarehouse: '/admin/warehouse',
    createWarehouse: '/admin/warehouse/create',
    detailWarehouse: '/admin/warehouse/:id',

    detailProduct: '/admin/products/detail/:id',
    products: '/products',
    product_categoty: '/products/:categoryName',
    product_detail: '/detail/:id',
    cart: '/cart',
    history: '/history/:id',
    login: '/login',
    register: '/register',
    shipping: '/shipping',
    profile: '/profile',
    about: '/about',
};

export default routes;
